import React from "react";
import ReactDOM from "react-dom";
import Calculator from "./components/Calculator";
import "./components/css/reset.css";
import "./components/css/style.css";

ReactDOM.render(<Calculator />, document.getElementById("root"));
